<template>
  <b-row>
    <div
      id="loadingmessage"
      style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;"
      v-if="loading"
    >
      <p style="position: absolute; color: White; top: 40%; left: 50%;">
        <img src="../../assets/loader.gif" />
      </p>
    </div>
    <b-col cols="12" xl="12">
      <transition name="slide">
        <b-card>
          <div slot="header" v-html="caption"></div>
          <div v-if="data.length > 0">
            <b-table
              :hover="hover"
              :striped="striped"
              :bordered="bordered"
              :small="small"
              :fixed="fixed"
              responsive="sm"
              :items="data"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              class="table-responsive cnt"
            >
            <template   id="pdcy" slot="photo" slot-scope="item" style="text-align:center;">
              <img v-if="item.item.photo!=null" v-bind:src="'http://13.232.14.77/u/'+item.item.photo" width="50px" height="50px" />
              <p v-else>No Image</p>
            </template>
              <template slot="_id" slot-scope="data">
                
                <!-- <span style="padding-left:20px!important;">
                  <router-link :to="'/turtleDetails/'+data.item._id ">
                    <b-button variant="success">View Details</b-button>
                  </router-link>
                </span>-->
                <span style="padding-left:20px!important;">
                  <router-link :to="'/editadmin/'+data.item._id ">
                    <b-button class="text-white" variant="info"><i class="fa fa-edit"></i></b-button>
                  </router-link>
                </span> 
              <span style="padding-left:20px!important;">
                  <b-button variant="danger" @click="deladmin(data.item._id)"><i class="fa fa-trash"></i></b-button>
                </span>
              </template>
            </b-table>
            <nav>
              <b-pagination
                size="sm"
                :total-rows="getRowCount(data)"
                :per-page="perPage"
                v-model="currentPage"
                prev-text="Prev"
                next-text="Next"
                hide-goto-end-buttons
              />
            </nav>
          </div>
          <div v-else>
            <p>No List Found</p>
          </div>
        </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
import axios from "axios";
export default {
  name: "Users",
  props: {
    caption: {
      type: String,
      default: "List of Admins"
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      items: [],
      type: localStorage.getItem("type"),
      errors: [],
      data: [],
      fields: [
        {
          key: "name",
          label: "Name",
          sortable: false,
          thClass: " cnt",
          tdClass: "cnt"
        }, 
        {
          key: "email",
          label: "Email",
          sortable: false,
          thClass: " cnt",
          tdClass: "cnt"
        },
        {
          key: "phone",
          label: "Mobile",
          sortable: false,
          thClass: " cnt",
          tdClass: "cnt "
        },
        {
          key: "organization",
          label: "Organization",
          sortable: false,
          thClass: " cnt",
          tdClass: "cnt we"
        },
        {
          key: "username",
          label: "Username",
          sortable: false,
          thClass: " cnt",
          tdClass: "cnt "
        },
        {
          key: 'photo',
          label: 'Profile Pic',
          sortable: false,
          thClass: " cnt",
          tdClass: "cnt-"
        },
        {
          label: " Action",
          key: "_id",
          sortable: false,
          thClass: "cnt",
          tdClass: "cnt w2e"
        }
      ],
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
      loading: false
    };
  },
  mounted: function() {
    this.getList();
  },
  methods: {
    deladmin(val) {
       this.loading = true;
      if (confirm("Are you sure?")) {
        this.loading = true;
        var data1={}
        data1["id"]=val
        data1["x-auth-token"]=localStorage.getItem("token")
        // data1["type"]='admin'
        axios({
          method: "POST",
          data: data1,
          url: "/user/removeuser/"
        })
          .then(response => {
             this.loading = false;
            if (response.data.status) { 
              this.getList();
              this.msg = response.data.msg;
            } else {
              this.loading= false;
              this.$router.push({ name: "adminslist" });
            }
          })
          .catch(err => {
             this.loading= false;
            this.errors.push(err);
            this.$router.push({ name: "adminslist" });
          });
      }
    },
    getList() {
      this.loading = true;
      axios({
        method: "GET",
        url: "/user/allUsers?type=Admin",
        // headers: {
        //   "x-auth-token": localStorage.getItem("token")
        // }
      })
        .then(response => {
          this.loading = false;

          if (response.data.status === true) {
            this.data = response.data.data;
            // for (var i = 0; i < this.data.length; i++) {
            //   if (this.data[i].photo === '') {
            //     var pic = this.data[i].photo
            //     pic = "No Image Available"
            //     this.data[i].photo = pic
            //   }
            // }
            this.loading = false;
          } else if (response.data.status === false) {
            this.loading = false;
          }
        })
        .catch(e => {
          this.loading = false;
          this.errors.push(e);
          this.msg = "failed";
        });
    },

    getBadge(status) {
      return status === "sucess"
        ? "success"
        : status === "initiate"
        ? "secondary"
        : status === "progress"
        ? "warning"
        : status === "failure"
        ? "danger"
        : "primary";
    },
    getRowCount(data) {
      return data.length;
    },
     // userLink(id) {
    //   return `users/${id.toString()}`;
    // },
    // rowClicked(data) {
    //   const userLink = this.userLink(data._id);
    //   this.$router.push({ path: userLink });
    // }
  }
};
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
.cnt{
  text-align:center!important;
}
.we{
  width: 80px !important;
}
.w2e{
  width: 150px !important;
}
</style>
